// Mock data for History component
// TODO: This file should be deleted in production

// Filter configuration - categories with colors and labels
export const mockFiltersData = {
  status: "OK",
  data: {
    filters: [
      {
        value: "CALLS",
        label: "Calls",
        color: "#2196F3"
      },
      {
        value: "SMS",
        label: "SMS",
        color: "#4CAF50"
      },
      {
        value: "DATA",
        label: "Internet",
        color: "#FF9800"
      },
      {
        value: "ROAMING",
        label: "Roaming",
        color: "#E91E63"
      },
      {
        value: "SERVICES",
        label: "Services",
        color: "#9C27B0"
      },
      {
        value: "OTHER",
        label: "Other",
        color: "#694A5F"
      }
    ]
  }
};

// Expenses data - transaction history
export const mockExpensesData = {
  status: "OK",
  data: {
    records: [
      // Recent transactions
      {
        type: "CALLS",
        label: "Voice Call",
        group_type: "CALLS",
        group_label: "Calls",
        is_group: false,
        color: "#2196F3",
        date: "25.11.2024",
        time: "14:23",
        price: 120,
        currency: "AMD",
        number: "+37477123456",
        traffic: "5.5 min"
      },
      {
        type: "SMS",
        label: "SMS",
        group_type: "SMS",
        group_label: "SMS",
        is_group: false,
        color: "#4CAF50",
        date: "25.11.2024",
        time: "13:45",
        price: 25,
        currency: "AMD",
        number: "+37477654321",
        traffic: "1 SMS"
      },
      {
        type: "DATA",
        label: "Internet",
        group_type: "DATA",
        group_label: "Internet",
        is_group: false,
        color: "#FF9800",
        date: "25.11.2024",
        time: "12:30",
        price: 500,
        currency: "AMD",
        number: "",
        traffic: "100 MB"
      },
      // Previous day
      {
        type: "CALLS",
        label: "Voice Call",
        group_type: "CALLS",
        group_label: "Calls",
        is_group: false,
        color: "#2196F3",
        date: "24.11.2024",
        time: "18:15",
        price: 250,
        currency: "AMD",
        number: "+37477987654",
        traffic: "12.3 min"
      },
      {
        type: "DATA",
        label: "Internet",
        group_type: "DATA",
        group_label: "Internet",
        is_group: false,
        color: "#FF9800",
        date: "24.11.2024",
        time: "16:22",
        price: 800,
        currency: "AMD",
        number: "",
        traffic: "250 MB"
      },
      {
        type: "ROAMING",
        label: "Roaming Call",
        group_type: "ROAMING",
        group_label: "Roaming",
        is_group: false,
        color: "#E91E63",
        date: "24.11.2024",
        time: "15:10",
        price: 1200,
        currency: "AMD",
        number: "+33123456789",
        traffic: "3.2 min"
      },
      // Older transactions
      {
        type: "SMS",
        label: "SMS",
        group_type: "SMS",
        group_label: "SMS",
        is_group: false,
        color: "#4CAF50",
        date: "23.11.2024",
        time: "20:30",
        price: 25,
        currency: "AMD",
        number: "+37477111222",
        traffic: "1 SMS"
      },
      {
        type: "SERVICES",
        label: "Value Added Service",
        group_type: "SERVICES",
        group_label: "Services",
        is_group: false,
        color: "#9C27B0",
        date: "23.11.2024",
        time: "14:45",
        price: 300,
        currency: "AMD",
        number: "1234",
        traffic: ""
      },
      {
        type: "OTHER",
        label: "Monthly Fee",
        group_type: "OTHER",
        group_label: "Other",
        is_group: false,
        color: "#694A5F",
        date: "22.11.2024",
        time: "09:00",
        price: 2500,
        currency: "AMD",
        number: "",
        traffic: ""
      },
      {
        type: "DATA",
        label: "Internet",
        group_type: "DATA",
        group_label: "Internet",
        is_group: false,
        color: "#FF9800",
        date: "22.11.2024",
        time: "11:20",
        price: 0,
        currency: "AMD",
        number: "",
        traffic: "1 GB"
      },
      // Some free services (price = 0)
      {
        type: "CALLS",
        label: "Free Call",
        group_type: "CALLS",
        group_label: "Calls",
        is_group: false,
        color: "#2196F3",
        date: "21.11.2024",
        time: "17:30",
        price: 0,
        currency: "AMD",
        number: "+37477555666",
        traffic: "8.5 min"
      },
      {
        type: "SMS",
        label: "Free SMS",
        group_type: "SMS",
        group_label: "SMS",
        is_group: false,
        color: "#4CAF50",
        date: "21.11.2024",
        time: "16:15",
        price: 0,
        currency: "AMD",
        number: "+37477777888",
        traffic: "1 SMS"
      }
    ],
    topups_sum: 15000,
    expenses_sum: 5645,
    topups_sum_currency: "AMD",
    expenses_sum_currency: "AMD"
  }
};

// Topups data - account recharge history
export const mockTopupsData = {
  status: "OK",
  data: {
    records: [
      {
        date: "25.11.2024",
        price: 5000,
        currency: "AMD",
        type: "ONLINE_PAYMENT"
      },
      {
        date: "20.11.2024",
        price: 3000,
        currency: "AMD",
        type: "CARD_PAYMENT"
      },
      {
        date: "15.11.2024",
        price: 2000,
        currency: "AMD",
        type: "BANK_TRANSFER"
      },
      {
        date: "10.11.2024",
        price: 5000,
        currency: "AMD",
        type: "ONLINE_PAYMENT"
      }
    ],
    topups_sum: 15000,
    topups_sum_currency: "AMD"
  }
};

// Redemption history - points redemption (complex nested structure)
export const mockRedemptionHistoryData = {
  status: "OK",
  message: "",
  data: {
    RedemptionLog: [
      {
        ChannelDesc: "External",
        ChannelId: 3,
        CustomerId: 0,
        CustomerTypeId: null,
        DeliveryAddress: null,  
        Error: null,
        FidelityLevelId: null,
        Id: 101000000000000125,
        ItemsLogs: {
          RedemptionItemsLog: {
            Cancelled: false,
            Command: {
              AvailableForBalanceHistory: true,
              AvailableForCancellations: false,
              AvailableForNotLogging: false,
              AvailableForNotifications: true,
              AvailableForPrices: false,
              AvailableForReasons: false,
              AvailableForRestrictions: true,
              AvailableForRewards: false,
              Description: "Redemption",
              ExternalCode: "REDEMPTION",
              Id: 20
            },
            CommandDateKey: "0001-01-01T00:00:00",
            CommandDateTime: "2024-11-20T14:23:34.561",
            CustomerId: 0,
            DeliveryChannel: {
              AreaId: null,
              DeliveryChannelTypeId: null,
              Description: null,
              Enabled: false,
              Id: 0,
              ShortDescription: "NA"
            },
            Error: null,
            Id: 101001000000000013,
            Notes: "",
            NumberOfunits: 1,
            PhysicalItem: false,
            PointsLogs: {},
            PricePointsPerUnit: 500,
            PriceProvisioningAmount: "500.00000",
            PriceProvisioningPlatformCodeId: null,
            ProvisioningPlatformCodeDescription: null,
            ProvisioningTransactionId: null,
            Reason: null,
            RedeemableItem: {
              AvailableStock: null,
              Description: "50 SMS to all networks for 30 days",
              Enabled: false,
              Id: 30086,
              Image: null,
              Name: "50 SMS",
              PhysicalItem: false,
              ProvisioningAmount: null,
              ProvisioningPlatformCodeId: null,
              RedeemableItemCatalogue: null,
              RedeemableItemCategory: null,
              RedeemableItemExternalReferenceId: null,
              RedeemableItemPrices: null
            },
            RedeemableItemId: 30086,
            RedemptionLogId: 101000000000000125,
            WalletType: {
              Description: "Default Points",
              ExternalCode: "WALLET_DEFAULT",
              Id: 2,
              IsDisabled: false,
              IsReadOnly: true,
              ShortDescription: "Default points"
            }
          }
        },
        RoleId: null,
        SendNotification: true,
        SourceDesc: "CRM",
        SourceExternalReferenceId: 1122,
        SourceId: 11,
        UserId: 0
      },
      {
        ChannelDesc: "External",
        ChannelId: 3,
        CustomerId: 0,
        CustomerTypeId: null,
        DeliveryAddress: null,
        Error: null,
        FidelityLevelId: null,
        Id: 101000000000000109,
        ItemsLogs: {
          RedemptionItemsLog: {
            Cancelled: false,
            Command: {
              AvailableForBalanceHistory: true,
              AvailableForCancellations: false,
              AvailableForNotLogging: false,
              AvailableForNotifications: true,
              AvailableForPrices: false,
              AvailableForReasons: false,
              AvailableForRestrictions: true,
              AvailableForRewards: false,
              Description: "Redemption",
              ExternalCode: "REDEMPTION",
              Id: 20
            },
            CommandDateKey: "0001-01-01T00:00:00",
            CommandDateTime: "2024-11-18T09:44:44.524",
            CustomerId: 0,
            DeliveryChannel: {
              AreaId: null,
              DeliveryChannelTypeId: null,
              Description: null,
              Enabled: false,
              Id: 0,
              ShortDescription: "NA"
            },
            Error: null,
            Id: 101001000000000012,
            Notes: "",
            NumberOfunits: 1,
            PhysicalItem: false,
            PointsLogs: {},
            PricePointsPerUnit: 300,
            PriceProvisioningAmount: "300.00000",
            PriceProvisioningPlatformCodeId: null,
            ProvisioningPlatformCodeDescription: null,
            ProvisioningTransactionId: null,
            Reason: null,
            RedeemableItem: {
              AvailableStock: null,
              Description: "100 minutes to all networks for 15 days",
              Enabled: false,
              Id: 30085,
              Image: null,
              Name: "100 minutes",
              PhysicalItem: false,
              ProvisioningAmount: null,
              ProvisioningPlatformCodeId: null,
              RedeemableItemCatalogue: null,
              RedeemableItemCategory: null,
              RedeemableItemExternalReferenceId: null,
              RedeemableItemPrices: null
            },
            RedeemableItemId: 30085,
            RedemptionLogId: 101000000000000109,
            WalletType: {
              Description: "Default Points",
              ExternalCode: "WALLET_DEFAULT",
              Id: 2,
              IsDisabled: false,
              IsReadOnly: true,
              ShortDescription: "Default points"
            }
          }
        },
        RoleId: null,
        SendNotification: true,
        SourceDesc: "CRM",
        SourceExternalReferenceId: 1122,
        SourceId: 11,
        UserId: 0
      },
      {
        ChannelDesc: "External",
        ChannelId: 3,
        CustomerId: 0,
        CustomerTypeId: null,
        DeliveryAddress: null,
        Error: {
          ErrorCode: 810,
          ErrorDescription: "Reward not applied",
          ErrorLevel: "",
          ErrorType: "Technical"
        },
        FidelityLevelId: null,
        Id: 101000000000000039,
        ItemsLogs: {
          RedemptionItemsLog: {
            Cancelled: false,
            Command: {
              AvailableForBalanceHistory: true,
              AvailableForCancellations: false,
              AvailableForNotLogging: false,
              AvailableForNotifications: true,
              AvailableForPrices: false,
              AvailableForReasons: false,
              AvailableForRestrictions: true,
              AvailableForRewards: false,
              Description: "Redemption",
              ExternalCode: "REDEMPTION",
              Id: 20
            },
            CommandDateKey: "0001-01-01T00:00:00",
            CommandDateTime: "2024-11-15T07:24:20.766",
            CustomerId: 0,
            DeliveryChannel: {
              AreaId: null,
              DeliveryChannelTypeId: null,
              Description: null,
              Enabled: false,
              Id: 0,
              ShortDescription: "NA"
            },
            Error: {
              ErrorCode: 810,
              ErrorDescription: "Reward not applied",
              ErrorLevel: "",
              ErrorType: "Technical"
            },
            Id: 101001000000000004,
            Notes: "",
            NumberOfunits: 1,
            PhysicalItem: false,
            PointsLogs: {},
            PricePointsPerUnit: null,
            PriceProvisioningAmount: null,
            PriceProvisioningPlatformCodeId: null,
            ProvisioningPlatformCodeDescription: null,
            ProvisioningTransactionId: 101001000000000004,
            Reason: null,
            RedeemableItem: {
              AvailableStock: null,
              Description: "1GB internet for 7 days",
              Enabled: false,
              Id: 30084,
              Image: null,
              Name: "1GB Internet",
              PhysicalItem: false,
              ProvisioningAmount: null,
              ProvisioningPlatformCodeId: null,
              RedeemableItemCatalogue: null,
              RedeemableItemCategory: null,
              RedeemableItemExternalReferenceId: null,
              RedeemableItemPrices: null
            },
            RedeemableItemId: 30084,
            RedemptionLogId: 101000000000000039,
            WalletType: {
              Description: "Default Points", 
              ExternalCode: "WALLET_DEFAULT",
              Id: 2,
              IsDisabled: false,
              IsReadOnly: true,
              ShortDescription: "Default points"
            }
          }
        },
        RoleId: null,
        SendNotification: false,
        SourceDesc: "CRM",
        SourceExternalReferenceId: 1,
        SourceId: 11,
        UserId: 0
      }
    ]
  }
};

// Balance history - points accumulation
export const mockBalanceHistoryData = {
  status: "OK",
  data: {
    BalanceLog: [
      {
        Id: 1001,
        CommandDatetime: "2024-11-20T10:30:00.000",
        Points: 150,
        Description: "Points earned from payment",
        WalletType: "WALLET_DEFAULT"
      },
      {
        Id: 1002,
        CommandDatetime: "2024-11-19T15:45:00.000",
        Points: 200,
        Description: "Bonus points for loyalty",
        WalletType: "WALLET_DEFAULT"
      },
      {
        Id: 1003,
        CommandDatetime: "2024-11-18T12:20:00.000",
        Points: 100,
        Description: "Points from referral",
        WalletType: "WALLET_DEFAULT"
      },
      {
        Id: 1004,
        CommandDatetime: "2024-11-17T09:15:00.000",
        Points: -500, // This will be filtered out (negative points)
        Description: "Points redeemed",
        WalletType: "WALLET_DEFAULT"
      },
      {
        Id: 1005,
        CommandDatetime: "2024-11-16T14:30:00.000",
        Points: 75,
        Description: "Points from special offer",
        WalletType: "WALLET_DEFAULT"
      },
      {
        Id: 1006,
        CommandDatetime: "2024-11-15T11:45:00.000",
        Points: 300,
        Description: "Monthly bonus points",
        WalletType: "WALLET_DEFAULT"
      },
      {
        Id: 1007,
        CommandDatetime: "2024-11-14T16:20:00.000",
        Points: 50,
        Description: "Birthday bonus",
        WalletType: "WALLET_DEFAULT"
      }
    ]
  }
};

// Error responses for testing error states
export const mockErrorResponse = {
  status: "ERROR",
  message: "Service temporarily unavailable. Please try again later."
};

export const mockInvalidDataResponse = {
  status: "INVALID_DATA",
  errors: {
    email: "Please enter a valid email address",
    token: "Invalid authentication token"
  }
};

// Function to simulate API delays
export const simulateApiDelay = (data, delay = 1000) => {
  return new Promise((resolve) => {
    setTimeout(() => resolve({ data }), delay);
  });
};
